import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const servicesHeader = css`
  margin-bottom: var(--space-300);
`;

export const storeServicesMainContainer = css`
  grid-area: 3 / 2 / 4 / 3;
  ${breakpoints.to.desktop} {
    grid-area: 5 / 1 / 6 / 2;
  }
  ${breakpoints.to.tablet} {
    grid-area: 4 / 1 / 5 / 2;
  }
`;

export const storeServicesList = css`
  display: grid;
  grid-row-gap: 24px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 48px 48px 48px;
  ${breakpoints.to.tablet} {
    grid-template-columns: 1fr;
    grid-template-rows: 48px 48px 48px 48px 48px 48px;
  }
`;

export const greenRound = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: var(--space-200);
  background-color: var(--brand-light);
  border-radius: 48px;
  transition: background-color 0.3s;
`;

export const servicesMainRow = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  span {
    transition: color 0.3s;
  }
  &:hover {
    span {
      color: var(--brand-dark) !important;
    }
  }
`;
